<template>
    <div class="my-10">
        <div class="flex justify-between mb-5">
            <h1 class="text-2xl font-bold">
                {{ $t('nav.media') }}
            </h1>
            <div class="flex gap-5 items-center">
                <button @click="toggleFilter(true)" class="hidden gap-2 items-center text-main-color bg-white p-2 rounded-lg max-lg:flex"><IconFilter/><p>{{ $t('page.filter') }}</p></button>
            </div>
        </div>
        <div class="grid grid-cols-4 gap-5">
            <div class="col-span-1">
                <MediaSide 
                @closeFilter="toggleFilter(false)"
                :filterState="filterState"
                routeName="medias" 
                :currentSubscription="currentSubscription" 
                :isVip="isVip" 
                :location="getLocation.id"
                :hideFilters="['currentCategory']"></MediaSide>
            </div>
            <div class="col-span-3 max-lg:col-span-4">
                <div class="grid grid-cols-3 gap-4 max-lg:grid-cols-2 max-md:grid-cols-2">
                    <template v-if="videos.length > 0">
                        <router-link v-for="item in videos" :key="item?.id" :to="{ name: 'mediaDetail', params: { id: item?.id } }">
                            <MediaCard :detail="item">
                            </MediaCard>
                        </router-link>
                    </template>
                    <div v-show="videos.length === 0 && loading === false">
                        <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.not_found') }}</p>
                    </div>

                </div>
                <div v-show="loading === true" class="flex justify-center mt-10" role="status">
                    <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin  fill-main-color">
                    </IconSpinner>

                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import api from '@/api';
import IconSpinner from '@icons/IconSpinner.vue';
import IconFilter from '@icons/IconFilter.vue';
import MediaCard from '@cmp/media/MediaCard.vue'
import MediaSide from '@cmp/media/MediaSide.vue'
// import SortButton from '@cmp/SortButton.vue'
// import { SORT_OPTIONS } from '@/constants'
import { updateLastSeen } from '@/helpers'
export default {
    name: 'medias',
    components: {
        MediaCard,
        MediaSide,
        IconSpinner,
        IconFilter
        // SortButton
    },
    watch: {
        // '$route.query.category': {
        //     //   immediate: true,
        //     async handler(newValue, oldValue) {
        //         if (newValue !== oldValue) {
        //             this.currentCategory = newValue
        //             this.videos = []
        //             await this.getVideos()
        //         }
             
        //     },
        // },
        '$route.query.subscription': {
            //   immediate: true,
            async handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.currentSubscription = newValue
                    this.videos = []
                    await this.getVideos()
                }

            },
        },
        '$route.query.is_vip': {
            //   immediate: true,
            async handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.isVip = newValue
                    this.videos = []
                    await this.getVideos()
                }
             
            },
        },
       
        // '$route.query.ordering': {
        //     //   immediate: true,
        //     async handler(newValue, oldValue) {
        //         if (newValue != oldValue) {
        //             this.currentSort = newValue
        //             this.page = 1
        //             this.videos = []
        //             await this.getVideos()
        //         }
             
        //     },
        // },
       
    },
    data() {
        return {
            loading: false,
            videos: [],
            // currentCategory: null,
            currentSubscription: null,
            isVip: null,
            // currentRelevancy: null,
            // currentSort: null,
            page: 1,
            count: 0,
            next: null,
            filterState: false

            // SORT_OPTIONS: SORT_OPTIONS,

        }
    },
    methods: {
        toggleFilter(e){
            this.filterState = e
            document.body.style.overflowY = e ? 'hidden' : 'initial'
        },
        infiniteScroll() {
            let scrollTop = document.documentElement.scrollTop
            let scrollHeight = document.documentElement.scrollHeight
            let clientHeight = document.documentElement.clientHeight
            if (scrollTop + clientHeight >= scrollHeight - 650) {
                if (this.next !== null && this.loading === false) {
                    this.page += 1
                    this.getVideos()
                }
            }
        },
        async getVideos() {
            this.loading = true
            try {
                const response = await api.get('posts/videos/', { params: { 
                    // categories: this.currentCategory, 
                    page: this.page, 
                    subscription: this.currentSubscription, 
                    is_vip: this.isVip,
                    // ordering: this.currentSort, 
                    location: this.getLocation.id } })
                const results = response.data.results
                results.forEach(element => {
                    this.videos.push(element)
                });
                this.count = response.data.count
                this.next = response.data.next
            } catch (e) {
                console.log(e)
            }
            this.loading = false

        },
        // async likeAction(id, like) {
        //     if (this.$store.authStatus === false) {
        //         this.$store.setState('loginModal', true)
        //         return
        //     }
        //     try {
        //         const response = await api.post(`exhibition/products/${id}/like/`, { is_liked: like });
        //         this.$store.getLiked('exhibition')
        //     } catch (e) {
        //         console.log(e)
        //     }
        // },
        // handleRelevancy (e){
        //     this.currentSort = e
        //     this.$router.push({ name: 'medias', query: { 
        //         category: this.currentCategory, 
        //         page: 1, 
        //         subscription: this.currentSubscription, 
        //         // ordering: this.currentSort, 
        //         location: this.getLocation.id } })
        // }
    },
    computed: {
        getLocation(){
            return JSON.parse(localStorage.getItem('selectedLocation')) || 1
        }
    },
    mounted() {
        window.addEventListener("scroll", this.infiniteScroll)
    },
    unmounted() {
        window.removeEventListener("scroll", this.infiniteScroll)
    },
    async created() {
        // this.currentCategory = this.$route.query.categor
        this.currentSubscription = this.$route.query.subscription
        this.isVip = this.$route.query.is_vip
        // this.currentSort = this.$route.query.sort_by
        // this.currentRelevancy = this.SORT_OPTIONS.filter((el) => el.value == this.currentSort)[0]
        await this.getVideos()
        updateLastSeen('videos')

    }
}

</script>

<style scoped></style>
